import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PageSliderComponent } from '../ui-components/page-slider/pageslider.component';
import { PagesRendererDirective } from '../ui-components/page-slider/render.component';
import { DotIndicatorComponent } from '../ui-components/page-slider/dotindicator.component';
import { NavButtonComponent } from '../ui-components/page-slider/navbutton.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        PageSliderComponent,
        PagesRendererDirective,
        DotIndicatorComponent,
        NavButtonComponent
    ],
    exports: [
        PageSliderComponent,
        PagesRendererDirective,
        DotIndicatorComponent,
        NavButtonComponent
    ]
})
export class SliderLibModule { }
